/**
 * @generated SignedSource<<070aafa15a9b19cecba49b1c3876fe41>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetArticleTitleArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetArticleTitleArticle";
};
export type helpersGetArticleTitleArticle$key = {
  readonly " $data"?: helpersGetArticleTitleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetArticleTitleArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetArticleTitleArticle"
};

(node as any).hash = "df15703303a14bb71728812737b180ed";

export default node;
